export default "__VITE_ASSET__BRL7ndj3__";